import { deleteAPI, getAPI, patchAPI, postAPI } from '@/store/api';
import { Action } from '@/store/api/actions';
import {
  CategoricalEmail,
  DryMatterConfiguration,
  FreeConsultRequest,
  HarvestLoadConfiguration,
  LatestSeasonDate,
  PaginatedSeason,
  Season,
  SeasonCalendar,
  SendUserEmail,
  SMTPSetting
} from '@/store/models/configuration';
import { EmailReset } from '@/store/models/jwt';

export default new (class ConfigurationAPI {
  public async getHarvestLoadConfiguration(
    id: number
  ): Promise<HarvestLoadConfiguration> {
    return await getAPI<HarvestLoadConfiguration>(`${Action.Farms}/${id}`);
  }

  public async updateHarvestLoadConfiguration(
    harvestLoadConfiguration: HarvestLoadConfiguration
  ): Promise<HarvestLoadConfiguration> {
    return await patchAPI<HarvestLoadConfiguration>(
      `${Action.Farms}/${harvestLoadConfiguration.id}`,
      harvestLoadConfiguration
    );
  }

  public async getSMTPSetting(query = ''): Promise<SMTPSetting> {
    return await getAPI<SMTPSetting>(Action.SMTPSettings, query);
  }
  public async updateSMTPSetting(setting: SMTPSetting): Promise<SMTPSetting> {
    return await postAPI<SMTPSetting>(Action.SMTPSettings, setting);
  }
  public async testSMTPSetting(
    email: EmailReset
  ): Promise<{ message: string }> {
    return await postAPI<{ message: string }>(Action.TestSMTPSettings, email);
  }

  public async getSeasons(query = ''): Promise<Season[]> {
    return await getAPI<Season[]>(Action.Season, query);
  }

  public async getSeasonCalendars(query = ''): Promise<PaginatedSeason> {
    return await getAPI<PaginatedSeason>(Action.SeasonCalendar, query);
  }

  public async getSeasonCalendarById(id: number): Promise<SeasonCalendar> {
    return await getAPI<SeasonCalendar>(
      Action.SeasonCalendarDetail.replace('<id>', `${id}`)
    );
  }

  public async getLatestSeasonDateByFarm(id: number): Promise<LatestSeasonDate> {
    return await getAPI<LatestSeasonDate>(
      Action.LatestSeasonDate.replace('<id>', `${id}`)
    );
  }

  public async createSeasonCalendar(
    season: SeasonCalendar
  ): Promise<SeasonCalendar> {
    return await postAPI<SeasonCalendar>(Action.SeasonCalendar, season);
  }

  public async updateSeasonCalendar(
    season: SeasonCalendar,
    id: number
  ): Promise<SeasonCalendar> {
    return await patchAPI<SeasonCalendar>(
      Action.SeasonCalendarDetail.replace('<id>', `${id}`),
      season
    );
  }

  public async deleteSeasonCalendar(id: number): Promise<void> {
    await deleteAPI(Action.SeasonCalendarDetail.replace('<id>', `${id}`));
  }

  public async sendCategoricalEmail(
    categoricalEmail: CategoricalEmail
  ): Promise<unknown> {
    return await postAPI(Action.SendCategoricalEmail, categoricalEmail);
  }

  public async sendUserEmail(email: SendUserEmail): Promise<unknown> {
    return await postAPI(Action.SendEmail, email);
  }

  public async sendFreeConsultRequest(
    freeConsultRequest: FreeConsultRequest
  ): Promise<unknown> {
    return await postAPI(Action.FreeConsultRequest, freeConsultRequest);
  }

  public async getDryMatterConfiguration(
    id: number
  ): Promise<DryMatterConfiguration> {
    return await getAPI<DryMatterConfiguration>(`${Action.Farms}/${id}`);
  }

  public async updateDryMatterConfiguration(
    dryMatterConfiguration: DryMatterConfiguration
  ): Promise<DryMatterConfiguration> {
    return await patchAPI<DryMatterConfiguration>(
      `${Action.Farms}/${dryMatterConfiguration.id}`,
      dryMatterConfiguration
    );
  }
})();
